<div class="container-fluid h-100">
  <router-outlet></router-outlet>
</div>